import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import OpenAILogo from '../assets/logos/openai.svg';
import GeminiLogo from '../assets/logos/gemini.svg';
import ClaudeLogo from '../assets/logos/claude.svg';
import DeepSeekLogo from '../assets/logos/deepseek.svg';

export const TechSection = () => {
  const { t } = useTranslation();

  const logos = [
    { src: OpenAILogo, key: 'openai' },
    { src: GeminiLogo, key: 'gemini' },
    { src: ClaudeLogo, key: 'claude' },
    { src: DeepSeekLogo, key: 'deepseek' },
  ];

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section className="section overflow-hidden py-8 sm:py-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-center mb-8 sm:mb-10"
      >
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2 sm:mb-3 px-4">
          {t('tech.title')}
        </h2>
        <p className="text-base sm:text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto px-4">
          {t('tech.subtitle')}
        </p>
      </motion.div>

      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-12 items-center justify-items-center max-w-[280px] sm:max-w-2xl lg:max-w-4xl mx-auto px-4"
      >
        {logos.map(({ src, key }) => (
          <motion.div
            key={key}
            variants={itemVariants}
            whileHover={{ scale: 1.05 }}
            className="relative group w-full flex items-center justify-center"
          >
            <div className="w-[60px] sm:w-[80px] md:w-[100px] lg:w-[120px] h-[60px] sm:h-[80px] md:h-[100px] lg:h-[120px] p-2 sm:p-3">
              <img
                src={src}
                alt={t(`tech.models.${key}.alt`)}
                className="w-full h-full object-contain dark:brightness-0 dark:invert transition-all duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-white/10 to-transparent dark:from-gray-900/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};